import script from "./PBTcalculations.vue?vue&type=script&setup=true&lang=js"
export * from "./PBTcalculations.vue?vue&type=script&setup=true&lang=js"

import "./PBTcalculations.vue?vue&type=style&index=0&id=36e30650&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e30650"]])

export default __exports__